var map = {
	"./ss-photo-brief01.jpg": 1705,
	"./ss-photo-brief02.jpg": 1706,
	"./ss-photo-brief03.jpg": 1707,
	"./ss-video-brief01.jpg": 1708,
	"./ss-video-brief02.jpg": 1709,
	"./ss-video-brief03.jpg": 1710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1704;